import { EventData } from 'services/Gtm/entities';
import { trackEvent } from 'services/Gtm/functions';
import { COMMON_TEST_IDS } from 'constants/testsIds/common';
import * as S from './NextRoundArrowStyles';

export interface NextArrowProps {
  className?: string;
  onClick?: () => void;
  trackingData?: EventData;
  dataCy?: string;
  ariaLabel?: string;
}

const NextRoundArrow = ({ className = '', onClick, trackingData, dataCy = '', ariaLabel }: NextArrowProps) => (
  <>
    <S.NextButtonShaded className={`${className} next-shade`} />
    <S.NextArrowWrapper
      className={`${className} next`}
      onClick={() => {
        if (onClick) onClick();
        if (trackEvent && trackingData) trackEvent({ ...trackingData, eventLabel: 'next arrow click' });
      }}
      data-cy={dataCy || COMMON_TEST_IDS.NEXT_ARROW}
      aria-label={ariaLabel ?? 'Next'}
      aria-labelledby='Next Button'
      role='presentation'
      title='Next Button'
    >
      <S.NextArrow />
    </S.NextArrowWrapper>
  </>
);

export default NextRoundArrow;
